module.exports = __webpack_public_path__ + "static/img/logo25.74182c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo25.jpg
// module id = odkV
// module chunks = 1